import { ExpectedTaskAnswerMetadata, Task } from "@jelly/lesson";

const items = [
  { id: "fd05d98a-ce1e-4602-9ca2-d56f73267219", content: "Hypertension", options: {} },
  { id: "e54b0930-2f65-45f0-a9d8-2c7b976caa25", content: "Ischemic heart disease", options: {} },
  { id: "9ba2e705-72d2-4d0a-a3d4-3741d636e963", content: "Sleep deprivation", options: {} },
  { id: "bf2d3574-2241-4f9c-841d-35d97c2d03e6", content: "Hyperacusis", options: {} },
  { id: "eff61c42-6ada-4afb-92f2-8173b1b6f7d2", content: "Tinnitus", options: {} },
  { id: "d9a59f26-e598-412d-9402-4da1cff18967", content: "Temporary threshold shift", options: {} },
];

export const task: Task = {
  id: "d84b4486-1aa1-44ad-9cb3-336b6c817684",
  solutionType: "select",
  type: "checkbox",
  options: {
    shuffle: true,
    isMultiple: true,
    columns: 2,
  },
  items,
};

export const expectedAnswerMetadata: ExpectedTaskAnswerMetadata = {
  solutionType: "select",
  data: [
    "fd05d98a-ce1e-4602-9ca2-d56f73267219",
    "e54b0930-2f65-45f0-a9d8-2c7b976caa25",
    "9ba2e705-72d2-4d0a-a3d4-3741d636e963",
  ],
};
